var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"monitorHead"},[_c('div',{staticClass:"title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"img_body"},[(_vm.img)?_c('img',{attrs:{"src":_vm.img,"alt":""}}):_vm._e(),(_vm.text)?_c('div',{staticClass:"img_text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }